import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import jwtDecode from 'jwt-decode';
import { AppConfig } from 'src/app/app.config';
import { EUserType } from 'src/app/domain/enum/user-type';
import { User } from 'src/app/domain/user';
import { SampleFilters } from 'src/app/model/sample-filters.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class CoreData {
    private USER_TYPE = `${this.config.getConfig('appName')}_USER_TYPE`;
    private LAST_SEARCH = `${this.config.getConfig('appName')}_LAST_SEARCH`;

    constructor(
        protected oauthService: OAuthService,
        private config: AppConfig) { }

    get Token() {
        return this.oauthService.getAccessToken();
        // return this.cookieService.get('IdToken');
    }

    getUserFromJWTToken() {
        if (!this.Token) {
            return;
        }
        const u = new User();
        const decodedToken = jwtDecode(this.Token) as any
        if (decodedToken) {
            u.Email = decodedToken.email;
            u.FirstName = decodedToken.given_name;
            u.LastName = decodedToken.family_name;
            u.PI_SRI = decodedToken['pi.sri'];
        }
        return u;
    }

    get User(): User | undefined {
        const user = this.getUserFromJWTToken()
        if (user)
            user.Type = this.UserType

        return user;
    }

    get LastSearch(): SampleFilters {
        if (localStorage.getItem(this.LAST_SEARCH)) {
            return JSON.parse(atob(localStorage.getItem(this.LAST_SEARCH)!));
        }
        return new SampleFilters;
    }

    set LastSearch(filters: SampleFilters) {
        if (filters) {
            localStorage.setItem(this.LAST_SEARCH, btoa(JSON.stringify(filters)));
        } else {
            localStorage.removeItem(this.LAST_SEARCH);
        }
    }

    get UserType() {
        return Number(localStorage.getItem(this.USER_TYPE)!);
    }

    set UserType(type: EUserType) {
        localStorage.setItem(this.USER_TYPE, type.toString());
    }

    get IsMobile() {
        return window.innerWidth < 960;
    }

    public get IsLoggedIn() {
        return this.Token && this.Token !== '' || false;
        // return this.cookieService.get('IdToken') !== '' || false
    }
}
